import FormSection from '~/components/form/FormSection.vue'
import Channels from '~/components/Channels.vue'
import ProductInternalStatusInfo from '~/components/product-edit/InternalStatusInfo.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:setup', () => {
    nuxtApp.vueApp.component('FormSection', FormSection)
    nuxtApp.vueApp.component('Channels', Channels)
    nuxtApp.vueApp.component('ProductInternalStatusInfo', ProductInternalStatusInfo)
  })
})
